import { DropdownValue } from 'components/generic-components/dropdown/type';
import {
  BridgeCountryRestrictionType,
  bridgeRestrictedCountries,
  bridgeSubDivisions,
  countriesWithValidWithdrawalMethods,
} from 'lib/countryList';

/**
 * Maps ISO 3166-1 alpha-3 country codes to their corresponding alpha-2 codes
 */
export const alpha3ToAlpha2: { [key: string]: string } = {
  AFG: 'AF',
  ALB: 'AL',
  DZA: 'DZ',
  ASM: 'AS',
  AND: 'AD',
  AGO: 'AO',
  AIA: 'AI',
  ATA: 'AQ',
  ATG: 'AG',
  ARG: 'AR',
  ARM: 'AM',
  ABW: 'AW',
  AUS: 'AU',
  AUT: 'AT',
  AZE: 'AZ',
  BHS: 'BS',
  BHR: 'BH',
  BGD: 'BD',
  BRB: 'BB',
  BLR: 'BY',
  BEL: 'BE',
  BLZ: 'BZ',
  BEN: 'BJ',
  BMU: 'BM',
  BTN: 'BT',
  BOL: 'BO',
  BES: 'BQ',
  BIH: 'BA',
  BWA: 'BW',
  BVT: 'BV',
  BRA: 'BR',
  IOT: 'IO',
  BRN: 'BN',
  BGR: 'BG',
  BFA: 'BF',
  BDI: 'BI',
  CPV: 'CV',
  KHM: 'KH',
  CMR: 'CM',
  CAN: 'CA',
  CYM: 'KY',
  CAF: 'CF',
  TCD: 'TD',
  CHL: 'CL',
  CHN: 'CN',
  CXR: 'CX',
  CCK: 'CC',
  COL: 'CO',
  COM: 'KM',
  COD: 'CD',
  COG: 'CG',
  COK: 'CK',
  CRI: 'CR',
  HRV: 'HR',
  CUB: 'CU',
  CUW: 'CW',
  CYP: 'CY',
  CZE: 'CZ',
  CIV: 'CI',
  DNK: 'DK',
  DJI: 'DJ',
  DMA: 'DM',
  DOM: 'DO',
  ECU: 'EC',
  EGY: 'EG',
  SLV: 'SV',
  GNQ: 'GQ',
  ERI: 'ER',
  EST: 'EE',
  SWZ: 'SZ',
  ETH: 'ET',
  FLK: 'FK',
  FRO: 'FO',
  FJI: 'FJ',
  FIN: 'FI',
  FRA: 'FR',
  GUF: 'GF',
  PYF: 'PF',
  ATF: 'TF',
  GAB: 'GA',
  GMB: 'GM',
  GEO: 'GE',
  DEU: 'DE',
  GHA: 'GH',
  GIB: 'GI',
  GRC: 'GR',
  GRL: 'GL',
  GRD: 'GD',
  GLP: 'GP',
  GUM: 'GU',
  GTM: 'GT',
  GGY: 'GG',
  GIN: 'GN',
  GNB: 'GW',
  GUY: 'GY',
  HTI: 'HT',
  HMD: 'HM',
  VAT: 'VA',
  HND: 'HN',
  HKG: 'HK',
  HUN: 'HU',
  ISL: 'IS',
  IND: 'IN',
  IDN: 'ID',
  IRN: 'IR',
  IRQ: 'IQ',
  IRL: 'IE',
  IMN: 'IM',
  ISR: 'IL',
  ITA: 'IT',
  JAM: 'JM',
  JPN: 'JP',
  JEY: 'JE',
  JOR: 'JO',
  KAZ: 'KZ',
  KEN: 'KE',
  KIR: 'KI',
  PRK: 'KP',
  KOR: 'KR',
  KWT: 'KW',
  KGZ: 'KG',
  LAO: 'LA',
  LVA: 'LV',
  LBN: 'LB',
  LSO: 'LS',
  LBR: 'LR',
  LBY: 'LY',
  LIE: 'LI',
  LTU: 'LT',
  LUX: 'LU',
  MAC: 'MO',
  MDG: 'MG',
  MWI: 'MW',
  MYS: 'MY',
  MDV: 'MV',
  MLI: 'ML',
  MLT: 'MT',
  MHL: 'MH',
  MTQ: 'MQ',
  MRT: 'MR',
  MUS: 'MU',
  MYT: 'YT',
  MEX: 'MX',
  FSM: 'FM',
  MDA: 'MD',
  MCO: 'MC',
  MNG: 'MN',
  MNE: 'ME',
  MSR: 'MS',
  MAR: 'MA',
  MOZ: 'MZ',
  MMR: 'MM',
  NAM: 'NA',
  NRU: 'NR',
  NPL: 'NP',
  NLD: 'NL',
  NCL: 'NC',
  NZL: 'NZ',
  NIC: 'NI',
  NER: 'NE',
  NGA: 'NG',
  NIU: 'NU',
  NFK: 'NF',
  MNP: 'MP',
  NOR: 'NO',
  OMN: 'OM',
  PAK: 'PK',
  PLW: 'PW',
  PSE: 'PS',
  PAN: 'PA',
  PNG: 'PG',
  PRY: 'PY',
  PER: 'PE',
  PHL: 'PH',
  PCN: 'PN',
  POL: 'PL',
  PRT: 'PT',
  PRI: 'PR',
  QAT: 'QA',
  MKD: 'MK',
  ROU: 'RO',
  RUS: 'RU',
  RWA: 'RW',
  REU: 'RE',
  BLM: 'BL',
  SHN: 'SH',
  KNA: 'KN',
  LCA: 'LC',
  MAF: 'MF',
  SPM: 'PM',
  VCT: 'VC',
  WSM: 'WS',
  SMR: 'SM',
  STP: 'ST',
  SAU: 'SA',
  SEN: 'SN',
  SRB: 'RS',
  SYC: 'SC',
  SLE: 'SL',
  SGP: 'SG',
  SXM: 'SX',
  SVK: 'SK',
  SVN: 'SI',
  SLB: 'SB',
  SOM: 'SO',
  ZAF: 'ZA',
  SGS: 'GS',
  SSD: 'SS',
  ESP: 'ES',
  LKA: 'LK',
  SDN: 'SD',
  SUR: 'SR',
  SJM: 'SJ',
  SWE: 'SE',
  CHE: 'CH',
  SYR: 'SY',
  TWN: 'TW',
  TJK: 'TJ',
  TZA: 'TZ',
  THA: 'TH',
  TLS: 'TL',
  TGO: 'TG',
  TKL: 'TK',
  TON: 'TO',
  TTO: 'TT',
  TUN: 'TN',
  TUR: 'TR',
  TKM: 'TM',
  TCA: 'TC',
  TUV: 'TV',
  UGA: 'UG',
  UKR: 'UA',
  ARE: 'AE',
  GBR: 'GB',
  UMI: 'UM',
  USA: 'US',
  URY: 'UY',
  UZB: 'UZ',
  VUT: 'VU',
  VEN: 'VE',
  VNM: 'VN',
  VGB: 'VG',
  VIR: 'VI',
  WLF: 'WF',
  ESH: 'EH',
  YEM: 'YE',
  ZMB: 'ZM',
  ZWE: 'ZW',
  ALA: 'AX',
};

export const countryList = countriesWithValidWithdrawalMethods();
export const computeCountryDropdownValues = ({
  excludeCountries = [],
}: {
  excludeCountries?: string[];
} = {}): DropdownValue[] => {
  const result = [];
  for (const code in countryList) {
    if (excludeCountries.includes(code)) {
      continue;
    }
    result.push({
      label: countryList[code].name,
      value: code,
      id: code,
      additionalValue: code,
    });
  }
  return result;
};

export const customCountryFilterLogic = (query: string, countries: DropdownValue[]) => {
  return countries
    .map((country) => {
      const labelStr = typeof country.label === 'string' ? country.label : '';
      const index = labelStr.toLowerCase().indexOf(query.toLowerCase());
      const score = index === 0 ? 1 : index > 0 ? 0.5 : 0;
      return { ...country, score };
    })
    .filter((country) => country.score > 0)
    .sort((a, b) => b.score - a.score);
};

export const computeNationalityDropdownValues = (): DropdownValue[] => {
  const result = [];
  for (const code in countryList) {
    result.push({
      label: countryList[code].nationality,
      value: countryList[code].nationality,
      id: code,
    });
  }
  return result;
};

// Map of country codes to their restriction status for quick lookup
const bridgeRestrictedCountryMap = bridgeRestrictedCountries.reduce(
  (acc, country) => {
    acc[country.code] = country.type;
    return acc;
  },
  {} as Record<string, BridgeCountryRestrictionType>,
);

/**
 * Checks if a user's country is supported by Bridge
 * @param countryCode ISO 3166-1 alpha-2 country code
 * @returns boolean indicating if the country is supported
 */
export const isBridgeCountrySupported = (countryCode: string): boolean => {
  const normalizedCountryCode = countryCode?.toUpperCase();
  // If country is not in the restricted list, it's supported
  return !bridgeRestrictedCountryMap[normalizedCountryCode];
};

/**
 * Gets a country's Bridge restriction status if any
 * @param countryCode ISO 3166-1 alpha-2 country code
 * @returns restriction type or undefined if country is supported
 */
export const getBridgeCountryRestrictionType = (countryCode: string): BridgeCountryRestrictionType | undefined => {
  const normalizedCountryCode = countryCode?.toUpperCase();
  return bridgeRestrictedCountryMap[normalizedCountryCode];
};

/**
 * Bridge not supported US States - New York and Alaska only.
 * Reference: https://bridge-docs.readme.io/docs/countries
 * Note: Florida and Louisiana can now transact with Bridge (as of December 2024).
 */
export const unsupportedUSAStates = ['NY', 'AK'];

const alpha2ToAlpha3: { [key: string]: string } = Object.entries(alpha3ToAlpha2).reduce((acc, [alpha3, alpha2]) => {
  acc[alpha2.toUpperCase()] = alpha3;
  return acc;
}, {});

/**
 * Get subdivisions (states/provinces/regions) for a country using its alpha2 code
 * @param alpha2 - Two letter ISO country code
 * @returns Array of subdivisions with name and code, sorted alphabetically by name
 */
export const getCountrySubdivisions = (alpha2: string): { name: string; code: string }[] => {
  // Convert alpha2 to alpha3 by finding the key in alpha3ToAlpha2 mapping
  const alpha3 = alpha2ToAlpha3[alpha2.toUpperCase()];
  if (!alpha3) return [];

  // Find the country in bridgeSubDivisions by matching alpha3
  const country = bridgeSubDivisions.find((country) => country.alpha3 === alpha3);
  let subdivisions = country?.subdivisions?.sort((a, b) => a.name.localeCompare(b.name)) || [];

  // Filter out unsupported USA states when country is US
  if (alpha2.toUpperCase() === 'US') {
    subdivisions = subdivisions.filter((subdivision) => !unsupportedUSAStates.includes(subdivision.code));
  }

  return subdivisions;
};

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

/** "PH" becomes "Philippines". Anything that is not a known two-letter code comes back as given. */
export const getCountryNameFromCode = (alpha2: string): string => {
  if (!/^[A-Za-z]{2}$/.test(alpha2)) return alpha2;
  try {
    return regionNames.of(alpha2.toUpperCase()) ?? alpha2;
  } catch {
    return alpha2;
  }
};
